import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags/utils.tsx';

const isArjGicPrefilledDataHandlingEnabled = () =>
	getBooleanFeatureFlag('arj.gic-pre-filled-data-handling_pkvuc', false);

export default isArjGicPrefilledDataHandlingEnabled;
